import { render, staticRenderFns } from "./ScheduleDashboard.vue?vue&type=template&id=1b6620b2&scoped=true&"
import script from "./ScheduleDashboard.vue?vue&type=script&lang=js&"
export * from "./ScheduleDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDashboard.vue?vue&type=style&index=0&id=1b6620b2&scoped=true&lang=css&"
import style1 from "./ScheduleDashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6620b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VChip,VContainer,VIcon,VTab,VTabItem,VTabs,VTabsItems})
